import { Injectable } from '@angular/core';
import { CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { EditorComponent } from '../pages/editor/editor.component';

@Injectable({
  providedIn: 'root'
})
export class UnsavedChangesGuard implements CanDeactivate<EditorComponent> {
  canDeactivate(component: EditorComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {

      const states = component.editroService.getCurrentStates();

      let state = states.filter(s=>s?.IsChanged);



      if(state.length>0){
        let leave =  window.confirm("You have unsaved cahnges. Are you sure you want to leave")
        if(leave){
          state.forEach(element => {
            element.IsChanged = false
          });
        }
        return leave;
      }
      return true;
  }


}
